import styled from 'styled-components';

export const ChartDescriptionArea = styled.div`
  flex: 1;
`;

export const DescriptionPercentArea = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
`;

export const DotDescription = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 8px;

  :before {
    background: ${props => props.color};
    border-radius: var(--size-border-radius-circle); //
    content: '';
    display: inline-flex;
    height: 16px;
    margin-right: 8px;
    position: relative;
    width: 16px;
  }
`;

export const RecipientCount = styled.div`
  margin-left: 16px;
`;
